import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Image } from "semantic-ui-react";
import { ICON_IMAGE_MAP } from "../../constants/iconMap.js";
import { IMAGE_VENDORS } from "../../constants/images.js";

class OSAvatar extends PureComponent {
  static propTypes = {
    entity: PropTypes.object
  };

  render = () => {
    const { entity } = this.props;
    if (!entity) return null;

    const { operatingSystem, vendor } = entity;
    if (!operatingSystem) return null;

    const imageKey = `${operatingSystem}${
      vendor && vendor === IMAGE_VENDORS.GOLDEN ? "Golden" : ""
    }`;

    return (
      <Image src={ICON_IMAGE_MAP[imageKey]} className="os-avatar" avatar />
    );
  };
}

export default OSAvatar;
